//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data(){
    return {
      domainList:Array,
      bubbleIndex:Number,
      pager: {
        page: '1',
        count: '1',
      },
      page: '1',
      count: '10',
    }
  },
  mounted() {
    this.getServer()
  },
  methods:{
    getServer(){
      let data = 'cmd=domain_list&page='+this.page+'&count='+this.count+'&keyword=&order_key=StartTime&order_type=desc'
      this.$http.post('https://api.abeiyun.com/www/domain.php', data).then(({data}) => {
        if(data.response == 200) {
          this.domainList = data.data.content.map((item)=>{
            return{
              id:item.id,
              domain:item.product_set,
              org:item.org,
              EndTime:item.EndTime,
              state:this.domainState(item.product_set,item.org) ? '' : '',
            }
          })
          this.pager.count = data.data.allpage
          this.pager.page = data.data.curpage
        }else {
          this.$router.push('/login')
        }
      })
    },
    async domainState(domain,org) {
      let data = 'cmd=smrz_query'+
        '&domain='+ domain +
        '&org='+ org
      this.$http.post('https://api.abeiyun.com/www/domain.php', data).then(({data}) => {
        if(data) {
          this.domainList.map((item, index) => {
            if(domain == item.domain){
              item.state = data
            }
          })
        }else {

        }
      })
    },
    pageNum(n, par) {
      if(par == 'up') {
        if(n > 1) {
          n = n - 1;
          this.page = n
          this.count = '10';
          this.getServer();
        }
      } else if(par == 'down') {
        if(n < this.pager.count) {
          n = parseInt(n) + 1;
          this.page = n
          this.count = '10';
          this.getServer();
        }
      }
    },
    Bubble(idx){
      if(this.bubbleIndex == idx){
        this.bubbleIndex = 10000
      }else{
        this.bubbleIndex = idx
      }
    },
    DomainManage(id) {
      this.$router.push('/user/domainmanage/'+ id)
    },
    Mange(id) {
      this.$router.push('/user/domainmanage/'+ id)
    },
    Renew(id) {
      this.$router.push('/user/domainrenew/'+ id)
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/domain.vue